module.exports = __webpack_public_path__ + "img/img39.0f19c2ee.svg";